(ns frontend.ui.page.lp-portal.news-editor.content-input.view
  (:require
   [herb.core :refer [<class]]
   [frontend.ui.page.lp-portal.news-editor.content-input.style :as style]
   [frontend.ui.component.lp-portal.field-title.view :as field-title]
   [frontend.ui.component.lp-portal.field.view :as field]
   [frontend.ui.page.lp-portal.news-editor.content-input.sub :as sub]
   [frontend.ui.page.lp-portal.news-editor.content-input.event :as event]
   [frontend.ui.component.lp-portal.file-upload.view :as file-upload]
   [reagent.core :as r]
   [re-frame.core :as rf]
   [cljs.core.async :as async]
   [cljs-http.client :as http]))

(defn content-input
  [props]
  (fn [{:keys [id value on-change]}]
    [field/field
     [field-title/field-title {:text "Content" :required true}]
     (if @(rf/subscribe [::sub/open?])
       [:div
        {:class (<class style/url-input-container)}
        [:i.fal.fa-times
         {:class    (<class style/close-icon)
          :on-click (fn [] (rf/dispatch [::event/toggle-open]))}]
        [:textarea
         {:auto-focus true
          :rows       3
          :class      (<class style/textarea)
          :value      value
          :on-change  (fn [event]
                        (-> event
                            .-target
                            .-value
                            on-change))}]]
       [file-upload/file-upload
        {:uploading         (= :uploading @(rf/subscribe [::sub/status]))
         :uploaded          (= :uploaded @(rf/subscribe [::sub/status]))
         :on-file           (fn [file]
                              (rf/dispatch [::event/set-status :uploading])
                              (async/go
                               (let [resp (async/<! (http/post "/lp-portal/api/create-op-token"))
                                     token (-> resp
                                               :body
                                               :body
                                               :token)
                                     resp (async/<! (http/post "/lp-portal-file-upload/api/file-upload"
                                                               {:multipart-params {:file            file
                                                                                   :module-name     :lp-portal-content
                                                                                   :filename        (.-name file)
                                                                                   :token           token
                                                                                   :user-account-id nil}}))
                                     url (:body resp)]
                                 (on-change url)
                                 (rf/dispatch [::event/set-status :uploaded]))))
         :on-type-url-click (fn [] (rf/dispatch [::event/toggle-open]))}])]))
